import { openobserveLogs } from '@openobserve/browser-logs';
import { openobserveRum } from '@openobserve/browser-rum';

import { createAnalytics } from './create-analytics';

// The SDKs are module singletons, so this wrapper is one too. Keeping the vendor
// imports in this file rather than create-analytics.ts is what lets the spec
// exercise the behaviour without pulling a browser SDK into a node test.
const analytics = createAnalytics({ rum: openobserveRum, logs: openobserveLogs });

export const initAnalytics = analytics.init;
export const trackAction = analytics.trackAction;
export const identifyUser = analytics.identifyUser;
export const clearUser = analytics.clearUser;
export const reportError = analytics.reportError;
